module.exports = __webpack_public_path__ + "static/img/glxt_06.742bf4f8.png";